export default "__VITE_ASSET__32b95b80__"